import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-modal-cart-shop-shedule',
    templateUrl: './modal-cart-shop-shedule.component.html',
    styleUrls: ['./modal-cart-shop-shedule.component.scss'],
    standalone: false
})
export class ModalCartShopSheduleComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit(): void {
  }
ngOnDestroy(): void {
  }
}
